/* =========================================================
   FARMOR'S — comportamiento del chrome (header, nav, barra de anuncio)

   Es js/main.js del prototipo menos el carrito: FARMORS.cart era una maqueta
   sobre localStorage que nunca llegaba al checkout, y en el tema lo reemplaza
   el cart-drawer de Dawn. Lo que queda es lo que Dawn no trae:

     1. Nav movil
     2. Barra de anuncio (cierre por sesion + --ann-h para el header overlay)
     3. Header sticky (.is-stuck: el fondo crema entra al scrollear)
     4. Puente del boton de carrito hacia el drawer de Dawn

   Sin dependencias y sin build, igual que el prototipo.
   ========================================================= */
(function () {
  "use strict";

  /* ---------------------------------------------------------
     1. Nav movil
     Delegado en document: el header es una seccion y el theme editor la
     re-renderiza al vuelo, asi que un listener sobre el boton se perderia
     en cada cambio.
     --------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest(".nav-toggle");
    if (!t) return;
    var nav = document.getElementById("main-nav");
    if (!nav) return;
    var open = nav.classList.toggle("is-open");
    t.setAttribute("aria-expanded", String(open));
  });

  /* ---------------------------------------------------------
     2. Barra de anuncio
     --ann-h es el alto real de la barra. El header en overlay lo lee para
     saber cuanto bajar; si la barra se cierra vuelve a 0 y el header sube.
     --------------------------------------------------------- */
  function setAnnHeight(h) {
    document.documentElement.style.setProperty("--ann-h", h + "px");
  }

  function announcementBar() {
    var bar = document.querySelector("[data-announcement]");
    if (!bar) {
      setAnnHeight(0);
      return;
    }

    // En el theme editor la barra tiene que verse siempre, aunque este
    // descartada: si no, el cliente la edita a ciegas.
    var dismissed = null;
    if (!window.Shopify || !window.Shopify.designMode) {
      try {
        dismissed = sessionStorage.getItem("farmors:announcement");
      } catch (err) {}
    }

    if (dismissed) {
      bar.remove();
      setAnnHeight(0);
      return;
    }

    setAnnHeight(bar.offsetHeight);
    window.addEventListener("resize", function () {
      setAnnHeight(bar.offsetHeight);
    });

    var close = bar.querySelector(".announcement-bar__close");
    if (close) {
      close.addEventListener("click", function () {
        try {
          sessionStorage.setItem("farmors:announcement", "1");
        } catch (err) {}
        bar.remove();
        setAnnHeight(0);
      });
    }
  }

  /* ---------------------------------------------------------
     3. Header sticky
     --------------------------------------------------------- */
  function stickyHeader() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var stuck = null;
    var sync = function () {
      var next = window.scrollY > 10;
      if (next === stuck) return; // solo tocamos el DOM cuando cambia
      stuck = next;
      header.classList.toggle("is-stuck", next);
    };
    sync();
    window.addEventListener("scroll", sync, { passive: true });
  }

  /* ---------------------------------------------------------
     4. Puente al cart drawer de Dawn
     El boton del header conserva el markup del prototipo; el drawer es el de
     Dawn, que si habla con /cart/*.js y llega al checkout.
     --------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-farmors-cart-open]");
    if (!btn) return;
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.open !== "function") return; // sin drawer, /cart
    e.preventDefault();
    drawer.open(btn);
  });

  /* ---------------------------------------------------------
     5. Toast
     Portado de la seccion 3 de js/main.js. En el prototipo confirmaba el alta
     al newsletter sin recargar. En Shopify el form SI recarga, asi que el toast
     se dispara al cargar la pagina cuando Liquid marco el envio como exitoso
     (data-farmors-toast en el body). El resultado en pantalla es el mismo.
     --------------------------------------------------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.setAttribute("role", "status");
      toastEl.setAttribute("aria-live", "polite");
      toastEl.setAttribute("aria-atomic", "true");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("is-visible");
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () {
      toastEl.classList.remove("is-visible");
    }, 2600);
  }

  /* ---------------------------------------------------------
     6. Arranque
     Se re-corre cuando el theme editor recarga una seccion, si no el header
     queda sin sticky y --ann-h desincronizado tras cada edicion.
     --------------------------------------------------------- */
  function init() {
    announcementBar();
    stickyHeader();
    var msg = document.body.getAttribute("data-farmors-toast");
    if (msg) {
      toast(msg);
      document.body.removeAttribute("data-farmors-toast"); // una sola vez
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", init);
})();

/* =========================================================
   PDP — variantes y cantidad

   Va aparte del IIFE de arriba porque solo aplica a la pagina de producto,
   pero comparte archivo para no sumar otro request.

   Todo es progresivo: el form ya funciona sin esto (el radio de variante
   manda su value y el submit agrega). Lo que agrega el JS es que el precio y
   la disponibilidad cambien sin recargar.
   ========================================================= */
(function () {
  "use strict";

  function initPdp() {
    var form = document.getElementById("pdp-form");
    if (!form) return;

    // --- Variantes: precio y disponibilidad en vivo ---
    var priceEl = document.getElementById("pdp-price");
    var availEl = document.getElementById("pdp-availability");
    var addBtn = form.querySelector(".pdp__add");

    form.addEventListener("change", function (e) {
      var input = e.target.closest("[data-pdp-variant]");
      if (!input) return;

      form.querySelectorAll(".pdp__variant").forEach(function (l) {
        l.classList.toggle("is-active", l.contains(input));
      });

      if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;

      var available = input.dataset.available === "true";
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? "Add to Cart" : "Sold out";
      }
      if (availEl) availEl.dataset.available = String(available);
    });

    // --- Cantidad ---
    var qty = document.getElementById("pdp-qty");
    form.addEventListener("click", function (e) {
      var btn = e.target.closest(".qty__btn");
      if (!btn || !qty) return;
      e.preventDefault();
      var next = (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.dir, 10);
      qty.value = next < 1 ? 1 : next;
    });

  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPdp);
  } else {
    initPdp();
  }
  document.addEventListener("shopify:section:load", initPdp);
})();
